<script>
import { orderIsCanPay, orderIsOffline } from '@utils/ipetbooking-order'
import { merchantComputed } from '@store/helpers'

export default {
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
    type: {
      type: String,
      default: 'reservation',
      validator(value) {
        return ['memberOrderReservation', 'memberOrderDaycare', 'memberOrderDeduct', 'memberOrderReservationChildren', 'reservation', 'daycare', 'prepaid', 'deduct', 'deposit'].includes(value)
      },
    },
    buttonClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...merchantComputed,
    isOffline() {
      const formatType = () => {
        const map = ['memberOrderReservation', 'memberOrderReservationChildren', 'memberOrderDaycare', 'memberOrderDeduct', 'reservation', 'daycare', 'deduct', 'deposit']
        return map.includes(this.type)
      }
      return orderIsOffline({
        order: this.orderItem,
        ordertype: 'order',
        type: formatType() ? 'reservation' : this.type,
      })
    },
    checkoutToPrepaid() {
      return this.orderItem.stores || this.orderItem.params
        ? {
            name: 'prepaid-unpaid-checkout',
            params: {
              storeType: this.type === 'deduct' ? this.orderItem.params[0].store.storeType : this.orderItem.stores[0].storeType,
              prepaidAlias: this.orderItem.prepaid.alias,
              orderId: this.type === 'deduct' ? this.orderItem.prepaid.id : this.orderItem.id,
            },
          }
        : ''
    },
    checkoutToReservation() {
      return {
        name: 'reservation-unpaid-checkout',
        params: {
          containerUuId: this.orderItem.uuid,
          // storeAlias: this.orderItem.param.store.alias,
          // reservationAlias: this.orderItem.param.alias,
          // orderId: this.orderItem.id
        },
      }
    },
    goToReservationDetail() {
      return {
        name: 'reservation-checkout-detail',
        params: {
          containerUuId: this.orderItem.containerUuid,
        },
      }
    },
    checkoutToDeposit() {
      return {
        name: 'deposit-unpaid-checkout',
        params: {
          orderId: this.orderItem.containerUuid || this.orderItem.uuid,
        },
      }
    },
    checkoutTo() {
      switch (this.type) {
        case 'prepaid':
          return this.checkoutToPrepaid
        case 'deposit':
          return this.checkoutToDeposit
        case 'deduct':
        case 'reservation':
        case 'daycare':
          return this.checkoutToReservation
        case 'memberOrderReservationChildren':
          return this.showDialogOrderDetails
        case 'memberOrderReservation':
        case 'memberOrderDaycare':
        case 'memberOrderDeduct':
        default:
          return this.goToReservationDetail
      }
    },
    checkoutDetailTo() {
      const type = this.type === 'deduct' ? 'prepaid' : this.type

      return {
        name: `${type}-checkout-detail`,
        params: {
          orderId: this.orderItem.id,
        },
      }
    },
    formatTypeTitle() {
      const typeTitleMap = {
        reservation: '預約',
        prepaid: `${this.currentMerchant.prepaidSetting.title || '包套方案'}`,
        deduct: `${this.currentMerchant.prepaidSetting.title || '包套方案'}`,
      }

      return typeTitleMap[this.type]
    },
    isCanPayPrepaid() {
      const orderItem = this.type === 'deduct' ? this.orderItem.prepaid : this.orderItem

      return orderIsCanPay(orderItem)
    },
    isCanPay() {
      // const orderItem = this.type === 'deduct'
      //   ? this.orderItem.prepaid
      //   : this.orderItem;

      return orderIsCanPay(this.orderItem)
    },
    paymentMethod() {
      return this.orderItem.paymentMethod
    },
    showButton() {
      let result
      const defaultShowBottom = () => {
        const isCanCheckoutPaymentMethod = this.orderItem.paymentMethod === 'Credit' || this.orderItem.paymentMethod === null
        const isNotCancel = this.orderItem.status !== 0 || !this.orderItem.cancelDate
        const isDeposit = this.type === 'deposit'
        const isDeduct = this.type === 'deduct'
        const isUnpaid =
          (!isDeposit && this.orderItem.status === 2) ||
          (isDeposit && this.orderItem.paymentStatus === 'UNPAID') ||
          (isDeduct && this.orderItem.paymentStatus === 'UNPAID') || // 包套已付款，加購尚未付款
          (isDeduct && this.orderItem.prepaid.status === 2) // 後台代訂未付款抵扣訂單
        return isNotCancel && isUnpaid && isCanCheckoutPaymentMethod
      }
      const containerListShowBottom = () => {
        const isCanCheckoutPaymentMethod = this.orderItem.paymentMethod === 'Credit' || this.orderItem.paymentMethod === null
        const isNotCancel = !this.orderItem.cancelDate
        const isUnpaid = this.orderItem.paymentStatus === 'UNPAID'

        return isNotCancel && isUnpaid && isCanCheckoutPaymentMethod
      }
      switch (this.type) {
        case 'reservation':
        case 'memberOrderReservationChildren':
          result = containerListShowBottom()
          break
        default:
          result = defaultShowBottom()
          break
      }
      return result
    },
  },
  methods: {
    showDialogOrderDetails() {
      this.$globalDialog('DialogOrderDetails', {
        type: 'children',
        containerItem: this.orderItem,
        isSingle: true,
      })
    },
  },
}
</script>
<!-- section template -->
<template>
  <div v-if="(showButton && !isOffline) || orderItem.paymentMethod === null" :class="$style.orderPaymentButton">
    <div :class="buttonClass">
      <template v-if="orderItem.prepaid && orderItem.prepaid.status > 0 && (orderItem.prepaid.paymentMethod === 'Credit' || orderItem.prepaid.paymentMethod === null)">
        <BaseButton v-if="isCanPayPrepaid" class="isFull" :class="`${$globalIsDingBeauty ? 'isStylePrimary' : 'isStyleSecondary isRadius  mb-3'}`" :to="checkoutToPrepaid">
          前往付款{{ `${currentMerchant.prepaidSetting.title || '包套方案'}` }}訂單
        </BaseButton>
      </template>
      <template v-if="type === 'prepaid' && orderItem.status > 1 && (orderItem.paymentMethod === 'Credit' || orderItem.paymentMethod === null) && !orderItem.cancelDate">
        <BaseButton v-if="isCanPay" class="isFull " :class="`${$globalIsDingBeauty ? 'isStylePrimary' : 'isStyleSecondary isRadius mb-3'}`" :to="checkoutTo">
          前往付款
        </BaseButton>
        <BaseButton v-else disabled class="isOutline isFull" :class="`${$globalIsDingBeauty ? 'isStylePrimary' : 'isStyleSecondary isRadius  mb-3'}`">
          已超過付款期限，無法付款
        </BaseButton>
      </template>
      <!-- 儲值金訂單在這邊 -->
      <template v-else-if="type !== 'prepaid' && orderItem.paymentStatus === 'UNPAID' && (orderItem.paymentMethod === 'Credit' || paymentMethod === null) && !orderItem.cancelDate">
        <BaseButton
          v-if="isCanPay && type !== 'memberOrderReservationChildren'"
          class="isFull"
          :class="`${$globalIsDingBeauty ? 'isStylePrimary' : 'isStyleSecondary isRadius  mb-3'}`"
          :to="checkoutTo"
        >
          前往付款
        </BaseButton>
        <!-- 子訂單跳彈窗 -->
        <BaseButton v-else-if="type === 'memberOrderReservationChildren'" class="isFull" :class="`${$globalIsDingBeauty ? 'isStylePrimary' : 'isStyleSecondary isRadius  mb-3'}`" @click="checkoutTo">
          前往付款
        </BaseButton>
        <BaseButton v-else disabled class="isOutline isFull" :class="`${$globalIsDingBeauty ? 'isStylePrimary' : 'isStyleSecondary isRadius  mb-3'}`">
          已超過付款期限，無法付款
        </BaseButton>
      </template>
    </div>
    <!--<template v-else-if="type === 'deduct'">
      <div :class="buttonClass">
        <BaseButton
          class="isStyleSecondary isOutline isFull isRadius mb-3"
          :to="checkoutDetailTo"
        >
          查看{{ formatTypeTitle }}訂單
        </BaseButton>
      </div>
    </template>-->
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.orderPaymentButton {
  :global {
    .orderPaymentButton {
      @include unstyled;
    }
  }
}
</style>
